// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeController_inputRoot__1PwcE","arrowIcon":"DateRangeController_arrowIcon__4dWsi"};